/**
 * Description:
 * 1. Mục đích: code các luồng liên quan đến giao dịch của tài khoản Follower
 */
import inqService from '@/stores/dataManager/apiServices/inqService';
import userDataService from '@/stores/dataManager/apiServices/userDataService';
import ToastUtil from '@/views/components/Toast/Toast';
import i18next from 'i18next';

export type ResponseSuccess = {
    isSuccess: boolean,
    data?: any,
    error?: any
}

export type ResponseSuccessPagination = {
    data: []
    pageIndex: number,
    pageSize: number,
    total: number,
}

// export const getDataInfoMF = async (accountId: string) => {
//     const param = {
//         config: {},
//         accountId
//     }
//     let result: ResponseSuccess = {
//         isSuccess: false,
//         data: null
//     }
//     await userDataService.getAccountInfoMF(param).then((data: any) => {
//         const { baldefovd, monthtraded, netasset, minmonthtraded, custodycd, minnetasset } = data?.[0]
//         result = {
//             isSuccess: true,
//             data: { baldefovd, monthtraded, netasset, minmonthtraded, custodycd, minnetasset }
//         }
//     }).catch(error => {
//         ToastUtil.errorApi(error, i18next.t('msgApi.error.lllllllllllllllllllllll'))
//         result = {
//             isSuccess: false,
//         }
//     })
//     return result
// }

export const submitRegisterMaster = async (
    linkAccount: string,
    tokenid: string,
    transactionId: string,
    authtype: string,
    code: string,
    isSaveVerify: boolean) => {
    const param = {
        config: {}
    }
    const body = {
        linkAccount,
        tokenid,
        transactionId,
        authtype,
        code,
        isSaveVerify
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        await userDataService.registerMasters(param, body)
        result = {
            isSuccess: true,
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.submitRegisterMaster'))
        result.error = error
    }
    return result
}

export const getMasterPointPublic = async (accountId: string) => {
    const param = {
        config: {},
        accountId
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.masterPointPublic(param) as any
        result = {
            isSuccess: true,
            data: {
                investperform: data[0]?.investperform || 0,
                masterpoint: data[0]?.masterpoint || 0,
                riskscore: data[0]?.riskscore || 0,
                totalassetcopier: data[0]?.totalassetcopier || 0,
            },
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getMasterPoint'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getMasterPointPrivate = async (accountId: string) => {
    const param = {
        config: {},
        accountId
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.masterPointPrivate(param) as any
        result = {
            isSuccess: true,
            data: {
                investperform: data[0]?.investperform || 0,
                masterpoint: data[0]?.masterpoint || 0,
                riskscore: data[0]?.riskscore || 0,
                totalassetcopier: data[0]?.totalassetcopier || 0,
            },
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getMasterPoint'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getPortfoliosPrivate = async (accountId: string, masterAccount: string, pageIndex: number, pageSize: number) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
        pageSize,
        pageIndex
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getPortfoliosPrivate(param)
        result = {
            isSuccess: true,
            data: data,
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getPortfolios'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getInvestPerformance = async (accountId: string, cosrole: string, timePeriod: string, timeType: string, masterCustodycd: string | null) => {
    const param = {
        config: {},
        accountId,
        masterCustodycd,
        timePeriod,
        timeType,
        cosrole
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.investPerformance(param)
        result = {
            isSuccess: true,
            data: data,
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getInvestPerformance'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getPNL = async (accountId: string, masterAccount: string, timePeriod: string, timeType: string) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
        timePeriod,
        timeType
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.pnlDaily(param)
        result = {
            isSuccess: true,
            data: data,
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getPNL'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getMasterDetail = async (acctno: string) => {
    const param = {
        config: {},
        typeOrder: 'ALL',
        acctno,
    }

    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }

    try {
        const response = await inqService.getMasterDetail(param) as any
        result = {
            isSuccess: true,
            data: response[0]
        };
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getMasterDetail'))
        result = {
            isSuccess: false,
        }
    }

    return result
}

export const getMasterThesis = async (acctno: string) => {
    const param = {
        config: {},
        typeOrder: 'ALL',
        acctno,
    }

    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }

    try {
        const response = await inqService.getMasterThesis(param) as any
        result = {
            isSuccess: true,
            data: response[0]
        };
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getMasterThesis'))
        result = {
            isSuccess: false,
        }
    }

    return result
}

export const getOrderHistoryPrivate = async (acctno: string, mtacctno: string, fromDate: string, toDate: string,
    pageIndex: number,
    pageSize: number) => {
    const param = {
        config: {},
        acctno,
        mtacctno,
        fromDate,
        toDate,
        pageIndex,
        pageSize
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.ordersHistoryPrivate(param)
        result = {
            isSuccess: true,
            data: data,
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getOrderHistory'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getOrderHistoryPublic = async (accountId: string, mtacctno: string, fromDate: string, toDate: string,
    pageIndex: number,
    pageSize: number) => {
    const param = {
        config: {},
        accountId,
        mtacctno,
        fromDate,
        toDate,
        pageIndex,
        pageSize
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.ordersHistoryPublic(param)
        result = {
            isSuccess: true,
            data: data,
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getOrderHistory'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getCopyHistory = async (accountId: string, masterAccount: string, fromDate: string, toDate: string,
    pageIndex: number,
    pageSize: number) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
        fromDate,
        toDate,
        pageIndex,
        pageSize
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getCopyTransHist(param)
        result = {
            isSuccess: true,
            data: data,
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getCopyHistory'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getTopCopyHistory = async (acctno: string, mtacctno: string, fromDate: string, toDate: string,
    pageIndex: number,
    pageSize: number) => {
    const param = {
        config: {},
        acctno,
        mtacctno,
        fromDate,
        toDate,
        pageIndex,
        pageSize
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getTopCopyHistoryService(param)
        result = {
            isSuccess: true,
            data: data,
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getCopyHistory'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getCommissionHistory = async (acctno: string, fromDate: string, toDate: string, pageIndex: number, pageSize: number) => {
    const param = {
        config: {},
        acctno,
        fromDate,
        toDate,
        pageIndex,
        pageSize
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getCommissionHistoryService(param)
        result = {
            isSuccess: true,
            data: data,
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getCommissionHistory'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getPNLHistoryPrivate = async (accountId: string, masterAccount: string, fromDate: string, toDate: string) => {
    const param = {
        config: {},
        accountId,
        masterAccount: masterAccount,
        fromDate,
        toDate,
        pageSize: 9999,
        pageIndex: 1,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getPnlDetailsHist(param)
        result = {
            isSuccess: true,
            data: data,
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getPNLHistory'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getPNLHistory = async (accountNo: string, masterAccount: string, fromDate: string, toDate: string) => {
    const param = {
        config: {},
        accountNo,
        masterAccount: masterAccount,
        fromDate,
        toDate,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getPNLHistoryPublic(param)
        result = {
            isSuccess: true,
            data: data,
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getPNLHistory'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getRankHistory = async (accountNo: string, fromDate: string, toDate: string, pageSize: number, pageIndex: number) => {
    const param = {
        config: {},
        accountNo,
        fromDate,
        toDate,
        pageSize,
        pageIndex
    }

    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }

    try {
        const response = await inqService.getRankHistoryService(param) as any
        result = {
            isSuccess: true,
            data: response
        };
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getRankHistory'))
        result = {
            isSuccess: false,
        }
    }

    return result
}

export const getAvlBuyPoint = async (acctno: string) => {
    const param = {
        config: {},
        typeOrder: 'ALL',
        acctno,
    }

    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }

    try {
        const response = await inqService.getAvlBuyPoint(param) as any
        result = {
            isSuccess: true,
            data: response[0]
        };
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getAvlBuyPoint'))
        result = {
            isSuccess: false,
        }
    }

    return result
}

export const getMasterReviewUnregis = async (accountId: string) => {
    const param = {
        config: {},
        accountId,
    }

    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }

    try {
        const response = await inqService.getMasterReviewUnregis(param) as any
        result = {
            isSuccess: true,
            data: response[0]
        };
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getMasterReviewUnregis'))
        result = {
            isSuccess: false,
        }
    }

    return result
}

export const postMasterInfo = async (masterAccountNo: string, body: { [key: string]: any }) => {
    let result: ResponseSuccess = {
        isSuccess: false,
    }
    const param = {
        config: {},
        masterAccountNo
    }
    try {
        await inqService.postMasterInfo(param, body)
        result = {
            isSuccess: true,
        };
    } catch (error) {
        console.log("🚀z3no3k  postMasterInfo  error:", error)
        ToastUtil.errorApi(error, i18next.t('msgApi.error.postMasterInfo'))
    }
    return result
}

export const postAvlBuyPoint = async (
    masterAccount: string,
    avlBuyPoint: string
) => {
    let result: ResponseSuccess = {
        isSuccess: false,
    }
    const param = {
        config: {}
    }
    try {
        await inqService.postAvlBuyPoint(param, { masterAccount, avlBuyPoint })
        result = {
            isSuccess: true,
        };
    } catch (error) {
        console.log("🚀z3no3k  postMasterInfo  error:", error)
        ToastUtil.errorApi(error, i18next.t('msgApi.error.postAvlBuyPoint'))
    }
    return result
}

export const submitDeleteAccountMaster = async (accountId: string, data: {
    tokenid: string,
    transactionId: string,
    authtype: string,
    code: string,
    isSaveVerify: boolean
}) => {
    const param = {
        config: {},
        body: data,
        accountId
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await userDataService.deleteAccountMaster(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: {}
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.submitDeleteAccountMaster'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

// const prepareDataForChart = (raw: any) => {
//     const dataForChart: any = {
//         time: [],
//         valueIndexDiff: [],
//         valueInvestDiff: []
//     }

//     for (let index = 0; index < raw.length; index++) {
//         const element = raw[index];
//         dataForChart.time.push(element.on_date)
//         dataForChart.valueIndexDiff.push(element.index_roi)
//         dataForChart.valueInvestDiff.push(element.ar_roi)
//     }
//     console.log('ha_check_prepareDataForChart', dataForChart);
//     return dataForChart
// }

// export const getInvestPerformanceBy = async (accountId: string = '0001000408', masterAccount: string = '', cosrole: string = COS_ROLE.M, timePeriod: number = 6, timeType: string = "M") => {
//     const param = {
//         config: {},
//         accountId,
//         masterAccount,
//         cosrole,
//         timePeriod,
//         timeType
//     }
//     let result: ResponseSuccess = {
//         isSuccess: false,
//         data: null
//     }
//     await inqService.getInvestPerformanceBy(param).then((data: any) => {
//         result = {
//             isSuccess: true,
//             data: prepareDataForChart(data),
//         }
//     }).catch(error => {
//         ToastUtil.errorApi(error, i18next.t('msgApi.error.lllllllllllllllllllllll'))
//         result = {
//             isSuccess: false,
//         }
//     })
//     return result
// }


// export const submitCopyMaster = async (body: any) => {
//     const param = {
//         config: {},
//         body
//     }
//     let result: ResponseSuccess = {
//         isSuccess: false,
//         data: null
//     }
//     await userDataService.copyMaster(param).then((data: any) => {
//         console.log('ha_check_registerFollower', data);
//         result = {
//             isSuccess: true,
//             data: {}
//         }
//     }).catch(error => {
//         ToastUtil.errorApi(error, i18next.t('msgApi.error.lllllllllllllllllllllll'))
//         result = {
//             isSuccess: false,
//         }
//     })
//     return result
// }
